import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'C減価償却Total',

  props: {
    /** 表示データ */
    values: {
      type: Array as PropType<number[]>,
    },
    /** 簡易表示 */
    isSimple: {
      type: Boolean,
      default: false,
    },
    /** 左の空白追加数 */
    blankColspan: {
      type: Number,
      default: 1,
    },
    unit: {
      type: Number,
      required: false,
    },
  },
});
